import React from 'react'
import classnames from 'classnames'
import LanguageIcon from '@material-ui/icons/Language'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core'

export type TranslationChipStatus = 'translated' | 'generating'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    borderRadius: 999,
    padding: theme.spacing(0.25, 1),
    backgroundColor: theme.paintscout.palette.secondary[230].C95,
    color: theme.palette.primary.main
  },
  icon: {
    fontSize: '1rem'
  },
  label: {
    ...theme.typography.subtitle2,
    lineHeight: 1
  }
}))

export interface TranslationStatusChipProps {
  /** 'generating' while a translation is being produced, 'translated' once active. */
  status: TranslationChipStatus
  className?: string
}

/**
 * Small pill shown next to the work-order title when viewing a non-English translation.
 * Renders "Generating…" while a translation is being produced and "Translated" once active.
 */
export default function TranslationStatusChip({ status, className }: TranslationStatusChipProps) {
  const classes = useStyles()
  const label = status === 'generating' ? 'Generating…' : 'Translated'

  return (
    <span className={classnames(classes.root, className)}>
      <LanguageIcon className={classes.icon} />
      <span className={classes.label}>{label}</span>
    </span>
  )
}
